module.exports = __webpack_public_path__ + "assets/ic_tree28.50cc7df4.svg";